import { useFadeUp } from '../hooks/usefadeup'
import './SobreNos.css'

const stats = [
  { value: '2022', label: 'Fundação' },
  { value: '100+', label: 'Clientes' },
  { value: '20+', label: 'Soluções' },
  { value: '100%', label: 'Moçambicana' },
]

export default function SobreNos() {
  const sectionRef = useFadeUp<HTMLElement>(800)

  return (
    <section id="sobre-nos" className="sn" ref={sectionRef}>
      <div className="sn-inner">

        {/* Left — 60% Image Hero */}
        <div className="sn-image-col" data-fade data-fade-delay="0">
          <img
            src="/sn_equipa.png"
            alt="Equipa Corporativa Makhowo em Maputo"
            className="sn-hero-img"
            loading="lazy"
          />
        </div>

        {/* Right — 40% Content */}
        <div className="sn-content-col">
          <div className="sn-header-wrapper" data-fade data-fade-delay="100">
            <h2 className="sn-title">Sobre Nós</h2>
          </div>

          <div className="sn-body-wrapper">
            <p className="sn-body sn-body--lead" data-fade data-fade-delay="150">
              Fundada em 2022, a Makhowo é uma corretora de seguros independente, de capital moçambicano, especializada na prestação de soluções estratégicas para a gestão e transferência de riscos, tanto para particulares como para empresas de diversos sectores de actividade.
            </p>
            <p className="sn-body" data-fade data-fade-delay="200">
              Comprometemo-nos a assegurar que os nossos clientes tenham acesso às melhores soluções de cobertura disponíveis no mercado, através de seguros especializados e personalizados, concebidos de acordo com as necessidades específicas de cada cliente e negócio. A nossa actuação abrange diversos sectores, com destaque para bens e serviços, mineração, logística, petróleo e gás, entre outros, oferecendo uma abordagem técnica orientada para a mitigação de riscos e a protecção sustentável das operações dos nossos clientes.
            </p>
            <p className="sn-body" data-fade data-fade-delay="250">
              Apoiados por uma equipa experiente, uma sólida rede de parceiros e modernas ferramentas de comunicação e acompanhamento, garantimos um serviço de consultoria ágil e eficiente assegurando que cada cliente beneficie de uma protecção adequada e de uma resposta célere e eficaz na gestão de sinistros.
            </p>
            <p className="sn-body" data-fade data-fade-delay="280">
              Na Makhowo, trabalhamos diariamente para construir relações de confiança duradouras, proporcionando tranquilidade, segurança e valor acrescentado aos nossos clientes.
            </p>
            <p className="sn-tagline" data-fade data-fade-delay="300">
              "Protegendo o seu futuro, uma apólice de cada vez."
            </p>
          </div>

          {/* Glassmorphism Stats */}
          <div className="sn-stats-grid" data-fade data-fade-delay="300">
            {stats.map(({ value, label }) => (
              <div key={label} className="sn-stat-glass">
                <span className="sn-stat-value">{value}</span>
                <span className="sn-stat-label">{label}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}